// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-square----styles-module---container---BRulr","square":"src-components-square----styles-module---square---3yr9G","children":"src-components-square----styles-module---children---2rUun"};


//////////////////
// WEBPACK FOOTER
// ./src/components/square/styles.module.css
// module id = 636
// module chunks = 168707334958949